var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 1024,
    viewBox: "0 0 1035 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_577_72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-191.958 579.467L934.349 -144.232L1034.05 -9.56584L-100.289 1083.94L-191.958 579.467Z",
    fill: "url(#paint0_linear_577_72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.093 579.257L-192.234 579.347L-192.204 579.512L-100.535 1083.99L-100.452 1084.45L-100.116 1084.12L1034.22 -9.38585L1034.38 -9.5382L1034.25 -9.71459L934.55 -144.381L934.41 -144.569L934.214 -144.443L-192.093 579.257Z",
    stroke: "url(#paint1_linear_577_72)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.093 579.257L-192.234 579.347L-192.204 579.512L-100.535 1083.99L-100.452 1084.45L-100.116 1084.12L1034.22 -9.38585L1034.38 -9.5382L1034.25 -9.71459L934.55 -144.381L934.41 -144.569L934.214 -144.443L-192.093 579.257Z",
    stroke: "url(#paint2_radial_577_72)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.093 579.257L-192.234 579.347L-192.204 579.512L-100.535 1083.99L-100.452 1084.45L-100.116 1084.12L1034.22 -9.38585L1034.38 -9.5382L1034.25 -9.71459L934.55 -144.381L934.41 -144.569L934.214 -144.443L-192.093 579.257Z",
    stroke: "url(#paint3_radial_577_72)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-192.093 579.257L-192.234 579.347L-192.204 579.512L-100.535 1083.99L-100.452 1084.45L-100.116 1084.12L1034.22 -9.38585L1034.38 -9.5382L1034.25 -9.71459L934.55 -144.381L934.41 -144.569L934.214 -144.443L-192.093 579.257Z",
    stroke: "url(#paint4_radial_577_72)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_577_72",
    x: -204.51,
    y: -156.906,
    width: 1251.22,
    height: 1253.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_577_72"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_577_72",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_72",
    x1: -306.389,
    y1: 555.106,
    x2: 140.838,
    y2: 966.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171215,
    stopColor: "#CABEE6",
    stopOpacity: 0.219
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96546,
    stopColor: "#252E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_72",
    x1: 832.563,
    y1: -302.156,
    x2: 1099.66,
    y2: 246.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_577_72",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-313.098 546.044) rotate(-22.5285) scale(1469.03 602.649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B82CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCC758",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_577_72",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-279.797 533.788) rotate(-22.586) scale(1433.57 585.527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7FE6",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_577_72",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-313.098 546.044) rotate(-22.5285) scale(1469.03 602.649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E76CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCF3F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRect);
export default __webpack_public_path__ + "static/media/rect.060a186b924a09706779644276f57e9f.svg";
export { ForwardRef as ReactComponent };